var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssetCustomClasses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.51479 7.49556C2.8442 7.8797 2.8442 8.84686 3.51479 9.231L10.8669 13.4425C11.1748 13.6189 11.5531 13.6189 11.861 13.4425L19.2131 9.231C19.8837 8.84686 19.8837 7.8797 19.2131 7.49556L11.861 3.28405C11.5531 3.10767 11.1748 3.10767 10.8669 3.28405L3.51479 7.49556Z",
    stroke: "black",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2626 10.3782L19.3395 11.5679C19.9807 11.9353 20.0157 12.8473 19.4045 13.2627L11.9261 18.3452C11.5868 18.5758 11.1411 18.5758 10.8019 18.3452L3.32343 13.2627C2.7122 12.8473 2.7472 11.9353 3.38847 11.5679L5.46533 10.3782",
    stroke: "black",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2626 15.015L19.3395 16.2046C19.9807 16.572 20.0157 17.484 19.4045 17.8994L11.9261 22.9819C11.5868 23.2125 11.1411 23.2125 10.8019 22.9819L3.32343 17.8994C2.7122 17.484 2.7472 16.572 3.38847 16.2046L5.46533 15.015",
    stroke: "black",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetCustomClasses);
export default __webpack_public_path__ + "static/media/asset-custom-classes.3e396a04d18ffc1e2686027372434efd.svg";
export { ForwardRef as ReactComponent };